import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Form, Button, Alert } from 'react-bootstrap';

/**
 * Stripe Payment Form Component
 * Handles credit card input using Stripe Elements
 */
function StripePaymentForm({ onPaymentSuccess, loading, setLoading }) {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [cardholderName, setCardholderName] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    setError(null);

    const cardElement = elements.getElement(CardElement);

    try {
      // Create payment method
      const { error: stripeError, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: cardholderName,
        },
      });

      if (stripeError) {
        setError(stripeError.message);
        setLoading(false);
        return;
      }

      // Call parent callback with payment method
      await onPaymentSuccess(paymentMethod);
      
    } catch (err) {
      setError(err.message || 'Payment failed. Please try again.');
      setLoading(false);
    }
  };

  const cardElementOptions = {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Name on card</Form.Label>
        <Form.Control
          type="text"
          value={cardholderName}
          onChange={(e) => setCardholderName(e.target.value)}
          placeholder="Enter name on card"
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Card details</Form.Label>
        <div className="form-control" style={{ padding: '12px' }}>
          <CardElement options={cardElementOptions} />
        </div>
        <Form.Text className="text-muted">
          Test card: 4242 4242 4242 4242 | Any future date | Any CVV
        </Form.Text>
      </Form.Group>

      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <Button
        type="submit"
        variant="success"
        size="lg"
        className="w-100"
        disabled={!stripe || loading}
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2"></span>
            Processing...
          </>
        ) : (
          'Pay Now'
        )}
      </Button>
    </Form>
  );
}

export default StripePaymentForm;
